import { createAsyncThunk } from '@reduxjs/toolkit';

import type { UserPermissionsResponse } from '@/types/auth';
import axiosInstance from '@/utils/axios';
import { getErrorMessage } from '@/utils/error-message';

/** `GET /users/me/permissions` — permission keys for the signed-in user. */
export const fetchUserPermissions = createAsyncThunk<string[], void, { rejectValue: string }>(
    'auth/fetchUserPermissions',
    async (_, { rejectWithValue }) => {
        try {
            const { data } = await axiosInstance.get<UserPermissionsResponse>('users/me/permissions');
            return Array.isArray(data?.permissions) ? data.permissions : [];
        } catch (error: unknown) {
            return rejectWithValue(getErrorMessage(error, 'Failed to fetch permissions'));
        }
    }
);
